var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="shopListItem_empty" class=""> <div id="shopListItem_col" class="col-xs-12 col-sm-12 col-md-12" style="padding-left: 0px; padding-right: 0px"> <div class="product clearfix"> <div class="image"> <a class="main" href="#"><img alt="" src="'+
((__t=( model.Image01 ))==null?'':__t)+
'"></a> </div> <div class="title"> <a class="name" href="#">'+
((__t=( model.Name ))==null?'':__t)+
'</a> <p class="description" style="display:block">'+
((__t=( model.Description01 ))==null?'':__t)+
'</p> </div> <div class="title" style="margin-bottom: 0px;border-bottom-width: 0px"> <h5 class="" style="float:left">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.ShowPrice ))==null?'':__t)+
'</h5> <span style="float:right">'+
((__t=( resources['X100850'] ))==null?'':__t)+
' '+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.Price ))==null?'':__t)+
'</span> </div> <div class="links"> <a class="cart" id="shopListItem_btnAddCart"><i class="fa fa-shopping-cart"></i><span>'+
((__t=( resources['X100848'] ))==null?'':__t)+
'</span></a> </div> </div> </div> </div> ';
}
return __p;
};
